import { Middleware} from "../middleware"
export default {
    getAxurLoki(filter){
        return new Middleware()
        .method('GET')
        .append('/loki/axur/all')
        .params({
            search: filter.search,
            page: filter.page,
            size: filter.size,
            startDate: filter.startDate,
            endDate: filter.endDate,
            idCompany: filter.idCompany,
        })
        .build()
    },

    getIntegrationsList(){
        return new Middleware()
        .method('GET')
        .append('/loki/integration-list')
        .build()
    },

    addIntegration(form){
        return new Middleware()
        .method('POST')
        .append('/loki/axur/add')
        .setData(form)
        .build()
    },
    putIntegration (payload) {
        return new Middleware()
            .method('PUT')
            .append(`/loki/axur/${payload.id}`)
            .params({
                idCompany: payload.clientid,
                status: payload.status
            })
            .build()
    },


    removeIntegration(payload){
        return new Middleware()
        .method('DELETE')
        .append(`/loki/axur/${payload.id}`)
        .params({
            idCompany: payload.company.idCompany
        })
        .build()
    }
}